export const SHOW_ALL_ID = '__all__'
export const SHOW_ALL_TEXT = 'すべて'
